import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { adminApi, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function ReportVersionsDialog({ intoStoreDate, eventKey = "", open, onClose, onChanged, list = adminApi.reportEdits, restoreFn = adminApi.restoreReportEdit }) {
  const [data, setData] = useState(null);
  useEffect(() => { if (open) { setData(null); list(intoStoreDate, eventKey).then(setData).catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message)); } }, [open, intoStoreDate, eventKey, list]);
  const restore = async (v) => {
    try { await restoreFn(v.id); toast.success(`Version ${v.version} is now current`); onChanged(); onClose(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="report-versions-modal">
        <DialogHeader><DialogTitle className="font-serif">Saved versions · {intoStoreDate}</DialogTitle></DialogHeader>
        {!data ? <div className="py-8 text-center"><Loader2 className="mx-auto h-5 w-5 animate-spin" /></div> : data.versions.length === 0 ? <p className="py-6 text-center text-sm text-[#28282E]/55">No saved edits yet — the report shows live order data.</p> : (
          <ul className="max-h-80 divide-y divide-slate-100 overflow-y-auto text-sm">
            {data.versions.map((v) => (
              <li key={v.id} data-testid={`version-${v.version}`} className="flex items-center justify-between gap-3 py-2">
                <div><div className="font-semibold text-[#28282E]">Version {v.version} {v.is_current && <span className="ml-1 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold text-amber-800">CURRENT</span>}</div><div className="text-xs text-[#28282E]/60">{String(v.saved_at).slice(0, 16).replace("T", " ")}{v.po_number ? ` · PO ${v.po_number}` : ""}{v.into_dc_date ? ` · DC ${v.into_dc_date}` : ""}{v.note ? ` · ${v.note}` : ""}</div></div>
                {!v.is_current && <Button data-testid={`version-restore-${v.version}`} size="sm" variant="outline" onClick={() => restore(v)} className="border-slate-200">Use this</Button>}
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
}
